<!--
Shows a search/list page for the Catalog
-->
<template>
  <auth-guard
    route
  >
    <v-container fluid>
      <base-title title="Catalogs" />
      <catalog-advanced-search />
    </v-container>
  </auth-guard>
</template>

<script>
import CatalogAdvancedSearch from './Components/CatalogAdvancedSearch'

export default {
  name: 'CatalogList',
  components: {
    CatalogAdvancedSearch
  }
}
</script>
